import { render, staticRenderFns } from "./BusinessDescrption.vue?vue&type=template&id=7c721869&scoped=true"
import script from "./BusinessDescrption.vue?vue&type=script&lang=js"
export * from "./BusinessDescrption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c721869",
  null
  
)

export default component.exports